<template>
  <div class="card">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-md-2 col-6">
          <base-input label="วันที่">
            <flat-picker class="form-control datepicker" v-model="startDate" />
          </base-input>
        </div>
        <div class="col-md-2 col-6">
          <base-input label="ถึง">
            <flat-picker class="form-control datepicker" v-model="endDate" />
          </base-input>
        </div>
        <div class="col-md-2 col-6">
          <base-input
            label="ค้นหา"
            labelClasses="text-white"
            placeholder="ค้นหา ..."
            v-model="searchQuery"
          />
        </div>
        <div class="col-md-6 col-12 search">
          <base-button
            type="default"
            @click="submitSearch()"
            :disabled="loading"
          >
            ค้นหา
          </base-button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <log-list-panel
            :_searchQuery="searchQuery"
            :count="dataCount"
            :data="logs"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import LogListPanel from "../backend-components/Log/LogListPanel";

import moment from "moment";
import tablePagination from "../mixins/tablePagination";
import LogService from "../services/log.service";

export default {
  components: {
    flatPicker,
    LogListPanel,
  },
  data() {
    return {
      loading: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      searchQuery: "",

      dataCount: 0,
      logs: [],
    };
  },
  methods: {
    async submitSearch() {
      this.loading = true;

      try {
        const res = await LogService.fetchLog({
          start: this.startDate,
          end: this.endDate,
        });

        this.dataCount = res.length;
        this.logs = res;
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.submitSearch();
  },
};
</script>
